<div svcTestId="ap-form-history__section--timeline-content" class="svc-history-tab">
  @if (historyService.loading()) {
    <div
      svcTestId="ap-form-history__section--loading"
      class="svc-data-loading svc-history-loading"
    >
      <mat-spinner diameter="35"></mat-spinner>
    </div>
  }  @else {
    <div svcTestId="ap-form-history__section--logs" class="svc-history-timeline">
      @for (log of historyService.historyLogs(); track log.id; let isLast = $last; let i = $index) {
        <div [svcTestId]="'ap-form-history__table-row--log-' + i" class="svc-history-item">
          <div class="svc-history-item-left">
            <div class="svc-history-item-icon text-primary" [ngSwitch]="getIconType(log.actionType)">
              <svg *ngSwitchCase="'escalated'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.2 3.8c-.33 0-.6.27-.6.6s.27.6.6.6h1.35L8.2 8.35 6.9 7.05a.6.6 0 0 0-.85 0L3.2 9.9a.6.6 0 1 0 .85.85l2.43-2.43 1.3 1.3a.6.6 0 0 0 .84 0l3.78-3.78v1.36a.6.6 0 1 0 1.2 0V4.4a.6.6 0 0 0-.6-.6h-2.8Z" fill="currentColor"/>
              </svg>

              <svg *ngSwitchCase="'rescheduled'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="5.5" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 5.2v2.95l2 1.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <svg *ngSwitchDefault width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 2.5h4l2 2V13H5V2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M9 2.5V4.5H11" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M8 7.2V10.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M6.5 8.7H9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="svc-history-item-line"></div>
          </div>

          <div class="svc-history-item-content">
            <div class="text-[11px] font-medium text-primary leading-6 mb-2">
              {{ log.date | dateFormat }} - {{ log.date | timeFormat : 'h:mm a' }}
            </div>
            <div class="font-sans font-medium text-base text-text-default leading-none" [class.mb-2]="log.details">{{ log.description }}</div>
            @if (log.details) {
              <div class="font-sans font-medium text-base text-text-default leading-none">
                <span>{{ 'Comentário' | transloco }}: {{ log.details }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
